
import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/context/LanguageContext';
import { useCustomLabels } from '@/hooks/useCustomLabels';

const VisitorInfoTeaser = () => {
  const { t, language } = useLanguage();
  const { getLabel } = useCustomLabels();
  
  return (
    <section className="mb-1 relative z-10">
      <Link to="/visitor-info" className="block p-6 rounded-xl overflow-hidden relative group">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/60 to-primary-foreground/60 transform transition-transform duration-500 group-hover:scale-105"></div>
        <div className="relative z-10">
          <h2 className="text-white text-2xl font-display font-bold mb-2">{getLabel('visitor_info_title', 'visitor_info')}</h2>
          <p className="text-white/90">
            {getLabel('visitor_info_subtitle', language === 'en' 
              ? "Opening hours, location, and more" 
              : "שעות פתיחה, מיקום ועוד")}
          </p>
        </div>
      </Link>
    </section>
  );
};

export default VisitorInfoTeaser;
